<template>
  <b-form-group :label-size="size" label="Аудитория" label-for="audienct-selector" label-class="mb-0">
    <b-form-select
      id="audienct-selector"
      v-model="internalSelectedAudienceId"
      :options="audienceOptions"
      :disabled="audienceSelectorDisabled"
      :size="size"
    />
  </b-form-group>
</template>

<script>
import { getAudienceName } from '../../model/m3level.js';

export default {
  name: 'AudienceSelector',

  props: {
    audienceIds: {
      type: Array,
      default: null,
    },

    audienceId: {
      type: Number,
      default: null,
    },

    size: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      internalSelectedAudienceId: this.audienceId,
    };
  },

  computed: {
    audienceOptions() {
      const DEFAULT_AUDIENCE_ID = null;

      const options = [
        {value: DEFAULT_AUDIENCE_ID, text: getAudienceName(DEFAULT_AUDIENCE_ID)},
      ];

      if(this.audienceIds === null) {
        return options;
      }

      for(const audienceId of this.audienceIds) {
        const option = {
          value: audienceId,
          text:  getAudienceName(audienceId),
        };
        options.push(option);
      }
      return options;
    },

    audienceSelectorDisabled() {
      return this.audienceIds === null || this.audienceIds.length === 0;
    }
  },

  watch: {
    audienceIds() {
      if(this.audienceIds === null || this.audienceIds.length === 0) {
        this.internalSelectedAudienceId = null;
      }
    },

    audienceId(newAudienceId) {
      if(this.internalSelectedAudienceId !== newAudienceId) {
        this.internalSelectedAudienceId = newAudienceId;
      }
    },
  },
}
</script>
